/* import __COLOCATED_TEMPLATE__ from './image-opener.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { ref } from 'ember-ref-bucket';

export default class ConversationControlInserterImageOpener extends Component {
  @service intercomEventService;

  analyticsName = 'image_inserter';
  @ref('inputElement') inputElement;

  @action
  handleClick(event) {
    this.intercomEventService.trackAnalyticsEvent({
      owner: 'inbox',
      action: 'clicked',
      object: this.analyticsName,
      place: 'inbox',
      context: this.analyticsName,
    });
  }

  @action
  handleChange(event) {
    let files = Array.from(event.target.files);
    if (files.length > 0) {
      this.inputElement.value = '';
      this.args.controlsAPI?.actions.uploadImage(files);
      this.args.inserterAPI?.actions.close();
    }
  }
}
